import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as csx from 'csstips';
import * as typestyle from 'typestyle';
import * as gls from '../../ap/layout/gls';
import * as styles from '../../ap/base/styles';
import { ButtonStyles } from '../../ap/base/button';
import { ProgressBar, Loader } from "../../ap/base/loader";
import { FieldStyles } from '../../ap/fields/field';
import * as validation from '../../ap/fields/validation/validation';
import { Anchor } from '../../ap/base/anchor';

export namespace DropzoneStyles {
  const dropzoneTextColor = styles.colors.warmGrey4;

  export const rootClassName = typestyle.style(
    csx.content,
    csx.flexRoot,
    csx.flex,
    {
      position: 'relative'
    }
  );
  export const buttonClassName = typestyle.style(
    csx.padding(24),
    csx.vertical,
    csx.centerCenter,
    {
      width: '100%',
      backgroundColor: styles.colors.white,
      color: dropzoneTextColor,
      borderStyle: 'dashed',
      borderColor: styles.colors.warmGrey3,
      borderWidth: '2px',
      cursor: 'pointer',
    }
  );

  export const input = {
    display: 'none'
  };
}

interface DropzoneProps {
  /**
   * Allows you to customize the dropzone UI
   */
  contents: React.ReactNode,

  /** Allows us to disconnect this dropzone from any backend implementation */
  onFileAdded: (file: File) => void;

  /**
   * Allows you to reject a file individually
   */
  validators?: validation.Validator<File>[];
  id?: string;
}

/**
 * - Holds a file
 * - Allows you to customize the UI (place holder)
 */
export class SingleFileDropzone extends React.Component<DropzoneProps, {
  rejectReason?: string | undefined,
  isDragActive?: boolean,
}> {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    /**
     * While some dropzone is on the page if a drop makes it to the `body` prevent default
     * Otherwise the page will reload and user will lose all state
     */
    window.addEventListener('dragover', this.preventDefault, false);
    window.addEventListener('drop', this.preventDefault, false);
  }

  componentWillUnmount() {
    window.removeEventListener('dragover', this.preventDefault, false);
    window.removeEventListener('drop', this.preventDefault, false);
  }

  // http://stackoverflow.com/a/6756680/390330
  preventDefault = (e) => {
    e = e || event;
    e.preventDefault();
  }

  ctrls: {
    root?: HTMLDivElement;
    input?: HTMLInputElement;
  } = {}
  render() {
    return (
      <div
  ref={(root) => { this.ctrls.root = root; }}
        className={DropzoneStyles.rootClassName}>
        <div
          className={DropzoneStyles.buttonClassName}
          onClick={(evt) => this.ctrls.input.click()}
          onDragLeave={this.onDragLeave} onDragOver={this.onDragOver} onDrop={this.onDrop}>

          {/* Purely for JS. Not visible */}
          <input
            id={this.props.id}
            ref={(input) => { this.ctrls.input = input; }}
            type="file"
            style={DropzoneStyles.input}
            multiple={false}
            onChange={this.handleChange}
            />

          {/** The visible stuff */}

          {
            this.props.contents
          }

          {
            !!this.state.rejectReason
            && <div className={FieldStyles.errorTextClassName} style={{paddingTop: '10px'}}>
            {this.state.rejectReason}
          </div>
          }

        </div>
      </div>
    );
  }

  handleChange = (evt: React.SyntheticEvent<any>) => {
    let fileInput = this.ctrls.input;
    let event = evt.nativeEvent;

    // Ignore the no file selected case
    if (!fileInput.value) {
      return;
    }

    // Copy the files to remove a direct link to FileList
    // Needed otherwise it becomes an empty array after we clear the input
    var files: File[] = Array.from<File>((event.target as any).files);

    // Add to queue
    this.addFilesToUploadQueue(files);

    // clear the input
    fileInput.value = "";
  }

  addFilesToUploadQueue = (files: File[]) => {
    /** Only support single files at the moment */
    const file = files[0];

    const rejectReason = validation.applyValidators(file, this.props.validators || []);
    if (rejectReason) {
      this.setState({ rejectReason });
      return;
    } else {
      this.setState({ rejectReason: undefined });
    }

    this.props.onFileAdded(file);
  }

  /**
   * Drag and drop support
   */
  onDragLeave = () => {
    this.setState({
      isDragActive: false,
    });
  }
  onDragOver = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    this.setState({
      isDragActive: true,
    });
  }
  onDrop = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();

    this.setState({
      isDragActive: false,
    });

    var files: File[];
    if ((e as any).dataTransfer) {
      files = (e as any).dataTransfer.files;
    } else if (e.target) {
      files = (e.target as any).files;
    }

    files = Array.prototype.slice.call(files);
    this.addFilesToUploadQueue(files);
  }
}

/** Uploads a file to the server */
export function uploadFile(config: {
  file: File,
  url: string,
  onProgress: (precent: number) => any,
  onSuccess: () => any,
  onFail: () => any,
}) {
  var xhr = new XMLHttpRequest();

  /** useful to store to prevent any onProgress after failure */
  let failed = false;

  // progress bar
  xhr.upload.addEventListener("progress", function(e: any) {
    if (failed) return;
    var pc = parseInt((e.loaded / e.total * 100).toString());
    config.onProgress(pc);
  }, false);

  // file received / failed
  xhr.onreadystatechange = function(e) {
    if (xhr.readyState == 4) {
      if (xhr.status == 200)
      {
        config.onSuccess()
      }
      else {
        failed = true;
        config.onFail();
      }
    };
  };

  // NOTE: this is our `doc-manager` specific stuff
  xhr.open("PUT", config.url, true); // We only use put

  // start upload
  xhr.send(config.file);
}
